/**
 * Warm by Design — Theme JS
 */
(function() {
  'use strict';

  // 1. Scroll-based nav background — only transparent on homepage
  var nav = document.getElementById('mainNav');
  if (nav) {
    var isHomepage = nav.classList.contains('nav-homepage');
    if (isHomepage) {
      window.addEventListener('scroll', function() {
        if (window.scrollY > 60) {
          nav.style.background = 'rgba(19,19,19,0.9)';
          nav.style.backdropFilter = 'blur(24px)';
          nav.style.webkitBackdropFilter = 'blur(24px)';
          nav.style.borderBottom = '1px solid rgba(245,188,112,0.1)';
        } else {
          nav.style.background = 'transparent';
          nav.style.backdropFilter = 'none';
          nav.style.webkitBackdropFilter = 'none';
          nav.style.borderBottom = '1px solid transparent';
        }
      }, { passive: true });
    }
  }

  // 2. IntersectionObserver for .fade-in elements
  var fadeObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) entry.target.classList.add('visible');
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.fade-in').forEach(function(el) { fadeObserver.observe(el); });
  document.addEventListener('shopify:section:load', function() {
    document.querySelectorAll('.fade-in:not(.visible)').forEach(function(el) { fadeObserver.observe(el); });
  });

  // 3. Cart helpers
  function formatMoney(cents) {
    return '$' + Math.ceil((Number(cents) || 0) / 100).toLocaleString('en-US');
  }

  var WBD_PROMO_CODE = 'SUMMER25';            // featured promo: drives the in-cart 25% display
  var WBD_DEPRECATED_PROMO_CODES = ['JULY25', 'SUMMER20'];
  var WBD_PROMO_CODE_KEY = 'wbdDiscountCode';   // legacy single-code key (kept in sync)
  var WBD_PROMO_APPLIED_KEY = 'wbdSummer25Applied';
  var WBD_LEGACY_PROMO_APPLIED_KEYS = ['wbdJuly25Applied', 'wbdSummer20Applied'];
  var WBD_CODES_KEY = 'wbdDiscountCodes';       // JSON array of applied codes
  var wbdDiscountCodesMemory = null;

  function normalizeDiscountCode(code) {
    return String(code || '').trim().toUpperCase();
  }
  function isDeprecatedPromoCode(code) {
    return WBD_DEPRECATED_PROMO_CODES.indexOf(normalizeDiscountCode(code)) !== -1;
  }
  function wbdEsc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // All applied discount codes (array). Migrates the old single-code storage.
  function appliedDiscountCodes() {
    try {
      var raw = window.localStorage.getItem(WBD_CODES_KEY);
      if (raw) {
        var arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          var out = [];
          arr.forEach(function(c) {
            c = normalizeDiscountCode(c);
            if (c && !isDeprecatedPromoCode(c) && out.indexOf(c) === -1) out.push(c);
          });
          return out;
        }
      }
      if (window.localStorage.getItem(WBD_PROMO_APPLIED_KEY) === 'true') {
        var legacy = normalizeDiscountCode(window.localStorage.getItem(WBD_PROMO_CODE_KEY));
        return legacy && !isDeprecatedPromoCode(legacy) ? [legacy] : [];
      }
    } catch (err) {}
    if (Array.isArray(wbdDiscountCodesMemory)) {
      return wbdDiscountCodesMemory.filter(function(c) { return !isDeprecatedPromoCode(c); });
    }
    return [];
  }
  function appliedDiscountCode() { var c = appliedDiscountCodes(); return c.length ? c[0] : ''; }

  // Back-compat: the in-cart 25%-off price display only triggers when the featured promo is applied.
  function summerDiscountApplied() { return appliedDiscountCodes().indexOf(WBD_PROMO_CODE) !== -1; }
  window.WBDSummerDiscountApplied = summerDiscountApplied;
  window.WBDAppliedDiscountCode = appliedDiscountCode;
  window.WBDAppliedDiscountCodes = appliedDiscountCodes;

  function writeDiscountCodes(codes) {
    var out = [];
    (codes || []).forEach(function(c) {
      c = normalizeDiscountCode(c);
      if (c && !isDeprecatedPromoCode(c) && out.indexOf(c) === -1) out.push(c);
    });
    wbdDiscountCodesMemory = out.slice();
    try {
      window.localStorage.setItem(WBD_CODES_KEY, JSON.stringify(out));
      WBD_LEGACY_PROMO_APPLIED_KEYS.forEach(function(key) {
        window.localStorage.removeItem(key);
      });
      if (out.length) {
        window.localStorage.setItem(WBD_PROMO_CODE_KEY, out[0]);
        window.localStorage.setItem(WBD_PROMO_APPLIED_KEY, 'true');
      } else {
        window.localStorage.removeItem(WBD_PROMO_CODE_KEY);
        window.localStorage.removeItem(WBD_PROMO_APPLIED_KEY);
      }
    } catch (err) {}
    return out;
  }

  // A checkout URL that applies every code in turn, then lands on redirectPath.
  function discountChainUrl(codes, redirectPath) {
    var url = redirectPath || '/checkout';
    for (var i = codes.length - 1; i >= 0; i--) {
      url = '/discount/' + encodeURIComponent(codes[i]) + '?redirect=' + encodeURIComponent(url);
    }
    return url;
  }
  function discountApplyUrl(code, redirectPath) {
    var cleanCode = normalizeDiscountCode(code);
    if (!cleanCode) return redirectPath || '/checkout';
    return '/discount/' + encodeURIComponent(cleanCode) + '?redirect=' + encodeURIComponent(redirectPath || '/checkout');
  }

  function applyDiscountToCartSession(code) {
    var url = discountApplyUrl(code, '/cart');
    if (url === '/cart' || url === '/checkout') return;
    try {
      fetch(url, {
        credentials: 'same-origin',
        redirect: 'follow',
        headers: { 'Accept': 'text/html' }
      }).catch(function() {
        var frame = document.getElementById('wbd-discount-session-frame');
        if (!frame) {
          frame = document.createElement('iframe');
          frame.id = 'wbd-discount-session-frame';
          frame.title = 'Discount session';
          frame.setAttribute('aria-hidden', 'true');
          frame.style.cssText = 'position:absolute;width:1px;height:1px;border:0;clip:rect(0 0 0 0);clip-path:inset(50%);overflow:hidden;';
          document.body.appendChild(frame);
        }
        frame.src = url;
      });
    } catch (err) {}
  }

  function setDiscountStatus(scope, message, state) {
    (scope || document).querySelectorAll('[data-discount-status]').forEach(function(status) {
      status.textContent = message || '';
      status.hidden = !message;
      if (state) { status.setAttribute('data-state', state); } else { status.removeAttribute('data-state'); }
    });
  }

  function renderDiscountChips(codes) {
    var html = codes.map(function(c) {
      if (c === WBD_PROMO_CODE) {
        return '<span class="wbd-dchip wbd-dchip--locked">' + wbdEsc(c) + '</span>';
      }
      return '<span class="wbd-dchip">' + wbdEsc(c) +
        '<button type="button" class="wbd-dchip__x" data-discount-remove="' + wbdEsc(c) +
        '" aria-label="Remove ' + wbdEsc(c) + '">✕</button></span>';
    }).join('');
    document.querySelectorAll('[data-discount-chips]').forEach(function(box) { box.innerHTML = html; });
  }

  function syncDiscountControls(root) {
    var codes = appliedDiscountCodes();
    var applied = codes.length > 0;
    var primary = applied ? codes[0] : '';
    document.querySelectorAll('[data-discount-checkout]').forEach(function(link) {
      link.href = applied ? discountChainUrl(codes, '/checkout') : '/checkout';
    });
    renderDiscountChips(codes);
    // Legacy single-code hooks (PDP / older markup).
    document.querySelectorAll('[data-discount-code-label]').forEach(function(label) {
      label.textContent = applied ? (codes.length > 1 ? codes.length + ' codes applied' : primary + ' applied') : (WBD_PROMO_CODE + ' available');
    });
    document.querySelectorAll('[data-discount-applied-code]').forEach(function(el) { el.textContent = primary; });
    document.querySelectorAll('[data-discount-apply]').forEach(function(control) {
      control.setAttribute('aria-pressed', applied ? 'true' : 'false');
      control.classList.toggle('is-applied', applied);
      control.textContent = applied ? 'Discount applied' : WBD_PROMO_CODE;
    });
    document.querySelectorAll('[data-discount-toggle]').forEach(function(toggle) {
      toggle.textContent = applied ? 'Applied' : 'Apply';
      toggle.setAttribute('aria-pressed', applied ? 'true' : 'false');
      toggle.classList.toggle('is-applied', applied);
    });
  }

  function addDiscountCode(code) {
    var clean = normalizeDiscountCode(code);
    if (!clean) return;
    if (isDeprecatedPromoCode(clean)) {
      ensureFeaturedPromoApplied();
      syncDiscountControls(document);
      setDiscountStatus(document, 'That code is no longer available.', 'error');
      return;
    }
    var codes = appliedDiscountCodes();
    if (codes.indexOf(clean) === -1) codes.push(clean);
    writeDiscountCodes(codes);
    applyDiscountToCartSession(clean);
    syncDiscountControls(document);
    document.dispatchEvent(new CustomEvent('wbd:discount-state-changed', { detail: { code: clean, applied: true, codes: codes } }));
    fetchCart().then(function(cart) { updateCartUI(cart, { skipGiftSync: true, openDrawer: false }); }).catch(function() {});
  }
  // Back-compat alias kept for any callers.
  function markDiscountApplied(code) { addDiscountCode(code); }

  function removeDiscountCode(code) {
    var clean = normalizeDiscountCode(code);
    if (clean === WBD_PROMO_CODE) {
      ensureFeaturedPromoApplied();
      syncDiscountControls(document);
      setDiscountStatus(document, WBD_PROMO_CODE + ' is already active.', 'ok');
      return;
    }
    var codes = appliedDiscountCodes().filter(function(c) { return clean ? c !== clean : false; });
    if (codes.indexOf(WBD_PROMO_CODE) === -1) codes.unshift(WBD_PROMO_CODE);
    writeDiscountCodes(codes);
    if (codes.length) { applyDiscountToCartSession(codes[codes.length - 1]); }
    syncDiscountControls(document);
    setDiscountStatus(document, '', '');
    document.dispatchEvent(new CustomEvent('wbd:discount-state-changed', { detail: { code: clean, applied: codes.length > 0, codes: codes } }));
    fetchCart().then(function(cart) { updateCartUI(cart, { skipGiftSync: true, openDrawer: false }); }).catch(function() {});
  }
  function removeDiscount() { removeDiscountCode(''); }

  function ensureFeaturedPromoApplied() {
    var codes = appliedDiscountCodes();
    var hadPromo = codes.indexOf(WBD_PROMO_CODE) !== -1;
    var next = [WBD_PROMO_CODE];
    codes.forEach(function(c) {
      if (c !== WBD_PROMO_CODE && next.indexOf(c) === -1) next.push(c);
    });
    writeDiscountCodes(next);
    if (!hadPromo) {
      applyDiscountToCartSession(WBD_PROMO_CODE);
      document.dispatchEvent(new CustomEvent('wbd:discount-state-changed', { detail: { code: WBD_PROMO_CODE, applied: true, codes: next } }));
    }
    return next;
  }

  ensureFeaturedPromoApplied();
  syncDiscountControls(document);
  document.addEventListener('shopify:section:load', function(event) {
    ensureFeaturedPromoApplied();
    syncDiscountControls(event.target);
  });

  document.addEventListener('submit', function(event) {
    var form = event.target.closest && event.target.closest('[data-discount-form]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('[data-discount-code-input]');
    var code = input ? normalizeDiscountCode(input.value) : '';
    var box = form.closest('[data-discount-box]') || document;
    if (!code) {
      setDiscountStatus(box, 'Enter a discount code.', 'error');
      if (input) input.focus();
      return;
    }
    if (appliedDiscountCodes().indexOf(code) !== -1) {
      setDiscountStatus(box, code + ' is already added.', 'error');
      if (input && !input.readOnly) input.value = '';
      return;
    }
    addDiscountCode(code);
    if (input && !input.readOnly) input.value = '';
    // Optimistic confirmation; Shopify finalizes the discount(s) at checkout.
    setDiscountStatus(box, code + ' added — applied at checkout.', 'ok');
  });

  // Remove a specific code (chip ✕); with no value, clears all.
  document.addEventListener('click', function(event) {
    var removeBtn = event.target.closest && event.target.closest('[data-discount-remove]');
    if (!removeBtn) return;
    event.preventDefault();
    removeDiscountCode(removeBtn.getAttribute('data-discount-remove') || '');
  });

  // Legacy toggle (older markup): apply the featured promo.
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest && event.target.closest('[data-discount-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var box = toggle.closest('[data-discount-box]');
    var form = box && box.querySelector('[data-discount-form]');
    if (form) form.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    addDiscountCode(WBD_PROMO_CODE);
  });

  // PDP / legacy "apply discount" controls still apply the featured promo.
  document.addEventListener('click', function(event) {
    var applyLink = event.target.closest && event.target.closest('[data-discount-apply]');
    if (!applyLink) return;
    event.preventDefault();
    addDiscountCode(WBD_PROMO_CODE);
  });

  var WBD_ROOM_PAIR_LAMP_TARGET = 2;
  var WBD_ROOM_PAIR_GIFTS = [
    { id: 47723843518615, name: 'Pocket Mini Lamp' },
    { id: 47715176841367, name: '2700K Replacement Bulb' }
  ];
  var WBD_ROOM_PAIR_GIFT_IDS = WBD_ROOM_PAIR_GIFTS.map(function(gift) { return Number(gift.id); });
  var WBD_ROOM_PAIR_EXCLUDED_HANDLES = {
    'pocket': true,
    'kit-2700k-replacement-bulb': true,
    'kit-lamp-care-kit': true,
    'kit-warm-layering-guide': true,
    'kit-beeswax-tapers': true
  };
  var wbdGiftSyncing = false;

  function updateLaunchClaimBadges() {
    var badges = document.querySelectorAll('[data-wbd-launch-claimed]');
    if (!badges.length) return;
    var text = '2+ lamps unlock free mini lamp + bulb';
    badges.forEach(function(badge) {
      badge.textContent = text;
      badge.setAttribute('aria-label', text);
    });
  }

  updateLaunchClaimBadges();
  window.setInterval(updateLaunchClaimBadges, 15 * 60 * 1000);
  document.addEventListener('shopify:section:load', updateLaunchClaimBadges);

  function normalizeKnownStaleProductLink(anchor) {
    if (!anchor || !anchor.href) return;
    var url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch (err) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    if (url.pathname !== '/products/loop') return;
    if (url.searchParams.has('variant')) return;
    url.searchParams.set('variant', '47771664285847');
    anchor.href = url.pathname + url.search + url.hash;
  }

  function normalizeKnownStaleProductLinks(root) {
    (root || document).querySelectorAll('a[href*="/products/loop"]').forEach(normalizeKnownStaleProductLink);
  }

  document.addEventListener('click', function(event) {
    normalizeKnownStaleProductLink(event.target.closest && event.target.closest('a[href]'));
  }, true);
  document.addEventListener('DOMContentLoaded', function() { normalizeKnownStaleProductLinks(document); });
  document.addEventListener('shopify:section:load', function(event) { normalizeKnownStaleProductLinks(event.target); });

  function isLaunchGift(item) {
    var props = item && item.properties ? item.properties : {};
    return props._wbd_launch_kit === 'gift' || (props._kit && String(props._kit).indexOf('gift') !== -1);
  }

  function lineHandle(item) {
    return String((item && (item.handle || item.product_handle)) || '').toLowerCase();
  }

  function qualifyingLampQuantity(cart) {
    return (cart.items || []).reduce(function(total, item) {
      if (isLaunchGift(item)) return total;
      if (WBD_ROOM_PAIR_EXCLUDED_HANDLES[lineHandle(item)]) return total;
      var productType = String((item && (item.product_type || item.productType)) || '').toLowerCase();
      if (productType.indexOf('lamp') === -1) return total;
      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  function displayCartTotal(cart) {
    return (cart.items || []).reduce(function(total, item) {
      if (isLaunchGift(item)) return total;
      return total + displayLinePrice(item);
    }, 0);
  }

  function hasAppliedLineDiscount(item) {
    return !!(item && item.original_line_price && item.original_line_price > item.final_line_price);
  }

  function displayLinePrice(item) {
    if (!item || isLaunchGift(item)) return 0;
    var current = item.final_line_price || item.line_price || 0;
    if (hasAppliedLineDiscount(item)) return current;
    return summerDiscountApplied() ? Math.round(current * 0.75) : current;
  }

  function cartHasGiftVariant(cart, variantId) {
    return (cart.items || []).some(function(item) {
      return isLaunchGift(item) && Number(item.variant_id) === Number(variantId);
    });
  }

  function isCurrentRoomPairGift(line) {
    return WBD_ROOM_PAIR_GIFT_IDS.indexOf(Number(line && line.variant_id)) !== -1;
  }

  function changeCartLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r) {
      if (!r.ok) return r.json().then(function(j) { throw new Error(j.description || 'Cart update failed'); });
      return r.json();
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
  }

  function syncLaunchKitGifts(cart) {
    if (!cart || wbdGiftSyncing) return Promise.resolve(cart);
    wbdGiftSyncing = true;
    return Promise.resolve(cart).then(function(current) {
      var qualifies = qualifyingLampQuantity(current) >= WBD_ROOM_PAIR_LAMP_TARGET;
      var giftLines = (current.items || []).filter(isLaunchGift);
      var work = Promise.resolve(current);

      if (!qualifies) {
        giftLines.forEach(function(line) {
          work = work.then(function() { return changeCartLine(line.key, 0); });
        });
        return work;
      }

      giftLines.forEach(function(line) {
        if (!isCurrentRoomPairGift(line)) {
          work = work.then(function() { return changeCartLine(line.key, 0); });
        } else if (line.quantity !== 1) {
          work = work.then(function() { return changeCartLine(line.key, 1); });
        }
      });

      return work.then(function(latest) {
        var missing = WBD_ROOM_PAIR_GIFTS.filter(function(gift) {
          return !cartHasGiftVariant(latest, gift.id);
        });
        if (!missing.length) return latest;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: missing.map(function(gift) {
              return {
                id: gift.id,
                quantity: 1,
                properties: {
                  _kit: 'gift-room-pair',
                  _wbd_launch_kit: 'gift',
                  'Room Pair Bonus': 'Free with 2+ lamps'
                }
              };
            })
          })
        }).then(function(r) {
          if (!r.ok) return r.json().then(function(j) { throw new Error(j.description || 'Gift add failed'); });
          return fetchCart();
        });
      });
    }).catch(function(err) {
      console.warn('[room-pair-bonus] sync failed', err);
      return cart;
    }).then(function(current) {
      wbdGiftSyncing = false;
      return current;
    });
  }

  function renderCartUI(cart, opts) {
    opts = opts || {};
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-cart-total]').forEach(function(el) {
      el.textContent = formatMoney(displayCartTotal(cart));
    });
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: cart, openDrawer: !!opts.openDrawer, skipGiftSync: !!opts.skipGiftSync }
    }));
  }

  function updateCartUI(cart, opts) {
    opts = opts || {};
    if (!opts.skipGiftSync) {
      return syncLaunchKitGifts(cart).then(function(syncedCart) {
        renderCartUI(syncedCart || cart, Object.assign({}, opts, { skipGiftSync: true }));
        return syncedCart || cart;
      });
    }
    renderCartUI(cart, opts);
    return cart;
  }

  document.addEventListener('cart:updated', function(e) {
    var detail = e.detail || {};
    if (!detail.cart || detail.skipGiftSync || wbdGiftSyncing) return;
    syncLaunchKitGifts(detail.cart).then(function(cart) {
      if (cart) updateCartUI(cart, { skipGiftSync: true, openDrawer: !!detail.openDrawer });
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    fetchCart().then(function(cart) {
      return updateCartUI(cart, { skipGiftSync: false, openDrawer: false });
    }).catch(function() {});
  });

  window.updateCartQuantity = function(lineIndex, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: quantity })
    }).then(function(r) { return r.json(); }).then(updateCartUI);
  };

  window.addToCart = function(variantId, quantity) {
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', quantity || 1);
    return fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          updateCartUI(cart);
          return item;
        });
      });
  };

  // Product pages can serve stale full-page HTML shortly after repricing.
  // Refresh the displayed buybox price from Shopify's current product JSON.
  function refreshProductPriceFromJson() {
    if (!/^\/products\//.test(window.location.pathname)) return;
    if (!document.querySelector('[data-price-display]')) return;
    fetch(window.location.pathname + '.js?price_refresh=' + Date.now(), {
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(product) {
        if (!product || !product.variants || !product.variants.length) return;
        var idInput = document.querySelector('[data-variant-id-input], form[action*="/cart/add"] input[name="id"]');
        var activeId = idInput ? String(idInput.value) : '';
        var variant = product.variants.filter(function(v) { return String(v.id) === activeId; })[0] || product.variants[0];
        if (!variant || typeof variant.price === 'undefined') return;
        var compareCents = variant.compare_at_price && variant.compare_at_price > variant.price
          ? variant.compare_at_price
          : variant.price;
        var displayCents = variant.compare_at_price && variant.compare_at_price > variant.price
          ? variant.price
          : Math.round(variant.price * 0.75);
        var price = formatMoney(displayCents);
        var compare = compareCents > displayCents ? formatMoney(compareCents) : '';
        document.querySelectorAll('[data-price-display]').forEach(function(el) {
          el.textContent = price;
        });
        document.querySelectorAll('[data-compare-display]').forEach(function(el) {
          el.textContent = compare;
          el.hidden = !compare;
        });
        document.querySelectorAll('[data-variant-price]').forEach(function(el) {
          if (!activeId || String(el.getAttribute('data-variant-id')) === activeId) {
            el.setAttribute('data-variant-price', price);
            el.setAttribute('data-variant-compare', compare);
          }
        });
      })
      .catch(function() {});
  }
  refreshProductPriceFromJson();

  // 4. Product page: variant selector
  document.addEventListener('click', function(e) {
    var variantBtn = e.target.closest('[data-variant-id]');
    if (variantBtn) {
      var form = variantBtn.closest('form');
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = variantBtn.dataset.variantId;
      }
      variantBtn.parentElement.querySelectorAll('[data-variant-id]').forEach(function(b) {
        b.classList.remove('bg-surface-container-high');
        b.classList.add('text-cream/45');
      });
      variantBtn.classList.add('bg-surface-container-high');
      variantBtn.classList.remove('text-cream/45');
    }
  });

  // 5. Intercept product form submissions — AJAX add, update cart count, no reload.
  // SKIPS the kit-configurator form (data-kit-cart-form) — that form has its own
  // handler that redirects directly to /checkout.
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (form.hasAttribute('data-kit-cart-form') || form.closest('[data-kit-cart-form]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    var origLabel = submitBtn ? submitBtn.textContent : null;
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json().then(function(j){ return { ok: r.ok, body: j }; }); })
      .then(function(result) {
        if (!result.ok) throw new Error(result.body.description || 'Add to cart failed');
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        // openDrawer=true pops the sidebar cart so the shopper sees what they added.
        updateCartUI(cart, { openDrawer: true });
        if (submitBtn) {
          submitBtn.textContent = 'Added ✓';
          setTimeout(function() {
            submitBtn.disabled = false;
            submitBtn.textContent = origLabel || 'Add to cart';
          }, 1400);
        }
      })
      .catch(function(err) {
        console.error('Add to cart failed:', err);
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origLabel || 'Add to cart'; }
        alert('Sorry — we couldn’t add that to your cart. Please try again.');
      });
  });

  // 6. Reviews widget loader: load the small PDP rating badge first and delay
  // the full reviews widget until its section is close to view.
  var WBD_REVIEWS_WIDGET_SRC = 'https://shopify-ai-chatbot-production-9ab4.up.railway.app/widget/warm/reviews.js';

  function installReviewWidgetLoader() {
    var badgeMounts = document.querySelectorAll('[data-wbd-review-badge][data-product-handle]');
    var lazyReviewMounts = document.querySelectorAll('[data-wbd-reviews-lazy][data-product-handle]');
    if (!badgeMounts.length && !lazyReviewMounts.length) return;

    function loadReviewWidgetScript(kind) {
      return new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.src = WBD_REVIEWS_WIDGET_SRC;
        script.async = true;
        script.defer = true;
        script.dataset.wbdReviewsScript = kind || 'reviews';
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    }

    function setFallbackMessage(mount, heading, detail) {
      var fallback = mount && mount.querySelector ? mount.querySelector('.wbd-reviews-fallback') : null;
      if (!fallback) return;
      var title = fallback.querySelector('p');
      var note = fallback.querySelector('.wbd-reviews-fallback__copy span');
      if (title && heading) title.textContent = heading;
      if (note && detail) note.textContent = detail;
    }

    function normalizeReviewBadge(mount) {
      if (!mount || mount.querySelector('.wbd-rating-compact')) return;
      var qrow = mount.querySelector('.wbd-rv-qrow');
      if (!qrow) return;
      var scoreEl = qrow.querySelector('.wbd-rv-score > span:first-child');
      var readEl = qrow.querySelector('.wbd-rv-read');
      if (!scoreEl || !readEl) return;

      var score = scoreEl.textContent.trim();
      var countMatch = readEl.textContent.match(/\d+/);
      var countText = countMatch ? countMatch[0] + ' reviews' : readEl.textContent.trim().toLowerCase();
      if (!score || !countText) return;
      var scoreNumber = parseFloat(score);
      var filledStars = Number.isFinite(scoreNumber) ? Math.round(scoreNumber) : 5;
      filledStars = Math.max(0, Math.min(5, filledStars));

      var row = document.createElement('span');
      var stars = document.createElement('span');
      var rating = document.createElement('span');
      var count = document.createElement('a');
      row.className = 'wbd-rating-compact';
      row.setAttribute('data-wbd-rv', '');
      stars.className = 'wbd-rating-compact__stars';
      stars.setAttribute('aria-label', filledStars + ' out of 5 stars');
      for (var i = 1; i <= 5; i += 1) {
        var star = document.createElement('span');
        star.className = 'wbd-rating-compact__star' + (i > filledStars ? ' is-empty' : '');
        star.textContent = '\u2605';
        stars.appendChild(star);
      }
      rating.className = 'wbd-rating-compact__score';
      rating.textContent = score;
      count.className = 'wbd-rating-compact__count';
      count.href = mount.getAttribute('data-review-href') || '#wbd-reviews';
      count.textContent = '(' + countText + ')';
      row.appendChild(stars);
      row.appendChild(rating);
      row.appendChild(count);
      mount.replaceChildren(row);
    }

    function normalizeReviewBadges() {
      badgeMounts.forEach(normalizeReviewBadge);
    }

    function markMainSlow(mount) {
      if (!mount) return;
      var loading = mount.querySelector('.wbd-rv-loading');
      if (!loading && !mount.querySelector('.wbd-reviews-fallback')) return;
      mount.dataset.wbdReviewsSlow = '1';
      if (loading) loading.textContent = 'Reviews are taking a moment...';
      setFallbackMessage(mount, 'Reviews are taking a moment.', 'You can keep browsing while they finish loading.');
    }

    function activateMainReviews(mount) {
      if (!mount || mount.dataset.wbdReviewsActivated === '1') return;
      mount.dataset.wbdReviewsActivated = '1';
      mount.setAttribute('data-wbd-reviews', '');
      setFallbackMessage(mount, 'Loading customer reviews.', 'This usually takes just a moment.');
      var slowTimer = setTimeout(function() { markMainSlow(mount); }, 4200);
      loadReviewWidgetScript('main')
        .then(function() {
          mount.dataset.wbdReviewsLoaded = '1';
        })
        .catch(function() {
          clearTimeout(slowTimer);
          mount.dataset.wbdReviewsError = '1';
          setFallbackMessage(mount, 'Reviews could not load right now.', 'Refresh the page or try again shortly.');
        });
    }

    if (badgeMounts.length) {
      badgeMounts.forEach(function(mount) {
        var observer = new MutationObserver(normalizeReviewBadges);
        observer.observe(mount, { childList: true, subtree: true });
      });
      normalizeReviewBadges();
      loadReviewWidgetScript('badge').catch(function() {
        badgeMounts.forEach(function(mount) {
          mount.dataset.wbdReviewsError = '1';
        });
      });
    }

    if (!lazyReviewMounts.length) return;
    if ('IntersectionObserver' in window) {
      var reviewObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          reviewObserver.unobserve(entry.target);
          activateMainReviews(entry.target);
        });
      }, { rootMargin: '900px 0px 900px 0px', threshold: 0 });
      lazyReviewMounts.forEach(function(mount) { reviewObserver.observe(mount); });
    } else {
      setTimeout(function() {
        lazyReviewMounts.forEach(activateMainReviews);
      }, badgeMounts.length ? 1600 : 300);
    }
  }

  // 7. Reviews widget: keep the write-review composer available but compact.
  // The widget is injected from the reviews service, so this observes for its
  // markup and collapses the form until the shopper explicitly opens it.
  function installReviewComposerOverrides() {
    if (!document.getElementById('wbd-review-composer-overrides')) {
      var style = document.createElement('style');
      style.id = 'wbd-review-composer-overrides';
      style.textContent = [
        '.wbd-rv-composer{margin-top:22px!important;border-color:rgba(245,188,112,.12)!important;background:rgba(24,24,26,.72)!important}',
        '.wbd-rv-composer-head{position:relative!important;cursor:pointer!important;padding:16px 20px!important;gap:14px!important}',
        '.wbd-rv-composer-head .e{margin-bottom:4px!important;font-size:10px!important;letter-spacing:.2em!important}',
        '.wbd-rv-composer-head h3{font-size:16px!important;line-height:1.22!important;letter-spacing:-.01em!important}',
        '.wbd-rv-composer-head .r{padding-right:78px!important;font-size:10px!important;color:rgba(240,237,232,.48)!important}',
        '.wbd-rv-composer-head:after{content:"Open form";position:absolute;right:20px;top:50%;transform:translateY(-50%);font-family:"Instrument Sans",ui-sans-serif,system-ui,sans-serif;font-size:10px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:rgba(245,188,112,.9)}',
        '.wbd-rv-composer[data-wbd-rv-composer-collapsed="false"] .wbd-rv-composer-head:after{content:"Close"}',
        '.wbd-rv-composer[data-wbd-rv-composer-collapsed="true"] .wbd-rv-composer-body,.wbd-rv-composer[data-wbd-rv-composer-collapsed="true"] .wbd-rv-composer-foot{display:none!important}',
        '.wbd-rv-composer-body{gap:14px!important;padding:18px 20px!important}',
        '.wbd-rv-field{gap:7px!important}',
        '.wbd-rv-field>.lbl{font-size:10px!important;letter-spacing:.18em!important}',
        '.wbd-rv-input,.wbd-rv-textarea{padding:11px 13px!important;font-size:14px!important}',
        '.wbd-rv-textarea{min-height:78px!important}',
        '.wbd-rv-dropzone{min-height:42px!important;padding:9px 13px!important}',
        '.wbd-rv-rater svg{width:22px!important;height:22px!important}',
        '.wbd-rv-composer-foot{padding:14px 20px!important}',
        '.wbd-rv-loading{padding:28px 0!important;border:1px solid rgba(245,188,112,.12)!important;background:rgba(245,188,112,.035)!important;color:rgba(240,237,232,.58)!important;font-size:11px!important;letter-spacing:.16em!important}',
        '@media(max-width:720px){.wbd-rv-composer{margin-top:24px!important}.wbd-rv-composer-head{padding:15px 16px!important}.wbd-rv-composer-head h3{max-width:250px!important;font-size:15px!important}.wbd-rv-composer-head .r{display:none!important}.wbd-rv-composer-head:after{right:16px;font-size:9.5px}.wbd-rv-composer-body{padding:16px!important;gap:13px!important}.wbd-rv-row2{gap:12px!important}.wbd-rv-rater svg{width:24px!important;height:24px!important}.wbd-rv-composer-foot{padding:14px 16px!important;gap:12px!important}.wbd-rv-composer-foot .wbd-rv-btn{padding:13px!important}}'
      ].join('');
      document.head.appendChild(style);
    }

    function setComposerOpen(composer, open) {
      composer.setAttribute('data-wbd-rv-composer-collapsed', open ? 'false' : 'true');
      var head = composer.querySelector('.wbd-rv-composer-head');
      if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function initComposer(composer) {
      if (!composer || composer.dataset.wbdComposerReady === '1') return;
      composer.dataset.wbdComposerReady = '1';
      setComposerOpen(composer, false);
      var head = composer.querySelector('.wbd-rv-composer-head');
      if (!head) return;
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.addEventListener('click', function() {
        setComposerOpen(composer, composer.getAttribute('data-wbd-rv-composer-collapsed') !== 'false');
      });
      head.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        setComposerOpen(composer, composer.getAttribute('data-wbd-rv-composer-collapsed') !== 'false');
      });
    }

    function initAllComposers() {
      document.querySelectorAll('.wbd-rv-composer').forEach(initComposer);
    }

    initAllComposers();
    if (!window.__wbdReviewComposerObserver) {
      window.__wbdReviewComposerObserver = new MutationObserver(initAllComposers);
      window.__wbdReviewComposerObserver.observe(document.documentElement, { childList: true, subtree: true });
    }

    if (!window.__wbdReviewWriteHandler) {
      window.__wbdReviewWriteHandler = true;
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.wbd-rv-write')) return;
        setTimeout(function() {
          var composer = document.querySelector('.wbd-rv-composer');
          if (composer) setComposerOpen(composer, true);
        }, 120);
      });
    }
  }

  function installMerchantMisrepRenderPatch() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    var pageType = '';
    if (path === '/pages/contact-us' || path === '/pages/contact') pageType = 'contact';
    if (path === '/pages/returns') pageType = 'returns';
    if (path === '/pages/reviews') pageType = 'reviews';

    function ready(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, { once: true });
      } else {
        fn();
      }
    }

    function addStaticStyles() {
      if (document.getElementById('wbd-merchant-static-styles')) return;
      var style = document.createElement('style');
      style.id = 'wbd-merchant-static-styles';
      style.textContent = [
        '.wbd-merchant-static{max-width:1120px;margin:0 auto;padding:80px 22px 96px;color:#f4efe7}',
        '.wbd-merchant-static__kicker{margin:0 0 14px;color:#f0b56b;font-size:12px;font-weight:800;letter-spacing:.18em;text-transform:uppercase}',
        '.wbd-merchant-static h1{margin:0 0 18px;font-size:clamp(36px,6vw,72px);line-height:.95;letter-spacing:0}',
        '.wbd-merchant-static__lead{max-width:720px;margin:0 0 34px;color:rgba(244,239,231,.76);font-size:18px;line-height:1.6}',
        '.wbd-merchant-static__grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px;margin-top:30px}',
        '.wbd-merchant-static__card{min-height:150px;border:1px solid rgba(244,239,231,.12);border-radius:8px;padding:22px;background:rgba(255,255,255,.035)}',
        '.wbd-merchant-static__card span{display:block;margin-bottom:10px;color:#f0b56b;font-size:11px;font-weight:800;letter-spacing:.16em;text-transform:uppercase}',
        '.wbd-merchant-static__card strong{display:block;margin-bottom:9px;font-size:20px;color:#fff}',
        '.wbd-merchant-static__card p{margin:0;color:rgba(244,239,231,.68);line-height:1.55}',
        '.wbd-merchant-static a{color:#f0b56b;text-underline-offset:4px}',
        '.wbd-merchant-static__actions{display:flex;flex-wrap:wrap;gap:12px;margin-top:26px}',
        '.wbd-merchant-static__button{display:inline-flex;align-items:center;justify-content:center;min-height:46px;border-radius:999px;padding:0 18px;background:#f0b56b;color:#16110d!important;font-weight:800;text-decoration:none}',
        '.wbd-merchant-static__button--ghost{background:transparent;color:#f0b56b!important;border:1px solid rgba(240,181,107,.42)}',
        '@media(max-width:760px){.wbd-merchant-static{padding:54px 18px 72px}.wbd-merchant-static__grid{grid-template-columns:1fr}.wbd-merchant-static__lead{font-size:16px}}'
      ].join('');
      document.head.appendChild(style);
    }

    function renderStaticPage(type) {
      var main = document.querySelector('main');
      if (!main || main.dataset.wbdMerchantStatic === type) return;
      addStaticStyles();
      var html = '';
      if (type === 'contact') {
        html = [
          '<section class="wbd-merchant-static" aria-label="Contact Warm by Design">',
          '<p class="wbd-merchant-static__kicker">Customer support</p>',
          '<h1>Contact Warm by Design</h1>',
          '<p class="wbd-merchant-static__lead">For order help, returns, product questions, or choosing warm 2700K lamps for a room, email support@warmbydesign.com. Include your order number when the question is about an existing purchase.</p>',
          '<div class="wbd-merchant-static__grid">',
          '<article class="wbd-merchant-static__card"><span>Email</span><strong><a href="mailto:support@warmbydesign.com">support@warmbydesign.com</a></strong><p>Primary customer service channel for order, return, warranty, and product questions.</p></article>',
          '<article class="wbd-merchant-static__card"><span>Response window</span><strong>1 to 2 business days</strong><p>Messages are reviewed during normal business hours.</p></article>',
          '<article class="wbd-merchant-static__card"><span>Business</span><strong>Warm by Design</strong><p>US online store for plug-in 2700K room lighting.</p></article>',
          '</div>',
          '<div class="wbd-merchant-static__actions"><a class="wbd-merchant-static__button" href="mailto:support@warmbydesign.com">Email support</a><a class="wbd-merchant-static__button wbd-merchant-static__button--ghost" href="/pages/returns">Returns</a><a class="wbd-merchant-static__button wbd-merchant-static__button--ghost" href="/pages/faq">FAQ</a></div>',
          '</section>'
        ].join('');
      } else if (type === 'returns') {
        html = [
          '<section class="wbd-merchant-static" aria-label="Warm by Design returns">',
          '<p class="wbd-merchant-static__kicker">Returns and refunds</p>',
          '<h1>Warm by Design Returns</h1>',
          '<p class="wbd-merchant-static__lead">Start a return within 30 days of delivery if your lamp is not right for the room. Keep the original packaging and included accessories until you know the order works for you.</p>',
          '<div class="wbd-merchant-static__grid">',
          '<article class="wbd-merchant-static__card"><span>Return window</span><strong>30 days from delivery</strong><p>Return eligibility starts from the day the carrier marks the order delivered.</p></article>',
          '<article class="wbd-merchant-static__card"><span>Condition</span><strong>Unused with packaging</strong><p>Send back the lamp, included accessories, and original packaging when possible.</p></article>',
          '<article class="wbd-merchant-static__card"><span>How to start</span><strong><a href="mailto:support@warmbydesign.com">support@warmbydesign.com</a></strong><p>Email the order number and the email used at checkout.</p></article>',
          '</div>',
          '<div class="wbd-merchant-static__actions"><a class="wbd-merchant-static__button" href="mailto:support@warmbydesign.com">Start a return</a><a class="wbd-merchant-static__button wbd-merchant-static__button--ghost" href="/policies/refund-policy">Refund policy</a><a class="wbd-merchant-static__button wbd-merchant-static__button--ghost" href="/policies/shipping-policy">Shipping policy</a></div>',
          '</section>'
        ].join('');
      } else if (type === 'reviews') {
        html = [
          '<section class="wbd-merchant-static" aria-label="Warm by Design reviews">',
          '<p class="wbd-merchant-static__kicker">Customer reputation</p>',
          '<h1>Warm by Design Reviews</h1>',
          '<p class="wbd-merchant-static__lead">Warm by Design uses public customer review surfaces so shoppers can evaluate the store before purchase. Review requests and product feedback are monitored alongside support questions at support@warmbydesign.com.</p>',
          '<div class="wbd-merchant-static__grid">',
          '<article class="wbd-merchant-static__card"><span>Public reviews</span><strong><a href="https://www.trustpilot.com/review/warmbydesign.com" rel="noopener" target="_blank">Trustpilot</a></strong><p>Open the public Warm by Design profile and read current customer feedback.</p></article>',
          '<article class="wbd-merchant-static__card"><span>Store standard</span><strong>2700K only</strong><p>Every lamp is positioned around warm 2700K room lighting.</p></article>',
          '<article class="wbd-merchant-static__card"><span>Need help?</span><strong><a href="mailto:support@warmbydesign.com">support@warmbydesign.com</a></strong><p>Contact support with order questions, product questions, returns, or warranty needs.</p></article>',
          '</div>',
          '<div class="wbd-merchant-static__actions"><a class="wbd-merchant-static__button" href="https://www.trustpilot.com/review/warmbydesign.com" rel="noopener" target="_blank">View Trustpilot</a><a class="wbd-merchant-static__button wbd-merchant-static__button--ghost" href="/pages/contact-us">Contact support</a></div>',
          '</section>'
        ].join('');
      }
      if (!html) return;
      main.dataset.wbdMerchantStatic = type;
      main.innerHTML = html;
    }

    function patchProductCopy() {
      if (window.location.pathname.indexOf('/products/') !== 0) return;
      document.querySelectorAll('[data-wbd-launch-claimed]').forEach(function(node) {
        node.textContent = '2+ lamps unlock free mini lamp + bulb';
      });
      document.querySelectorAll('.pdp-launch-kit__flag').forEach(function(node) {
        node.textContent = '2+ lamps unlock free mini lamp + bulb';
      });
      document.querySelectorAll('.pdp-bb__limited-note').forEach(function(node) {
        node.textContent = 'Made to order. Ships in 3~4 weeks';
      });
      document.querySelectorAll('.pdp-bb__trust-lbl').forEach(function(node) {
        if (node.textContent.trim() === '2-year warranty') {
          node.textContent = '1-year warranty';
        }
      });
    }

    function patchProductFaq() {
      if (window.location.pathname.indexOf('/products/') !== 0) return;
      var faqList = document.querySelector('.wd-faq__list');
      if (!faqList || faqList.dataset.wbdPdpFaqPatched === 'true') return;

      var currentText = faqList.textContent || '';
      if (currentText.indexOf('What kind of light does ') === -1 && currentText.indexOf('Where should I use ') === -1) return;

      var titleNode = document.querySelector('.pdp-bb__title, h1');
      var productTitle = titleNode ? titleNode.textContent.trim() : (document.title || 'This lamp').split('|')[0].trim();
      productTitle = productTitle.replace(/\s+-\s+Warm by Design$/i, '').replace(/\s+/g, ' ').trim() || 'This lamp';

      var pageText = (document.body.textContent || '').replace(/\s+/g, ' ');
      var isFloor = /floor lamp/i.test(pageText) || /floor/i.test(productTitle);
      var isTable = /table lamp/i.test(pageText) || /table/i.test(productTitle);
      var isDimmable = /dimmable/i.test(pageText);
      var bulbMatch = pageText.match(/Bulb(?:\/base)?\s*:?\s*([A-Z0-9-]{2,12})/i);
      var bulbText = bulbMatch ? bulbMatch[1] : '';
      var colorMatch = pageText.match(/\b(2700K)\b/i);
      var colorTemperature = colorMatch ? colorMatch[1].toUpperCase() : '2700K';

      function esc(value) {
        return String(value || '').replace(/[&<>"']/g, function(char) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
        });
      }

      function item(question, answer, open) {
        return [
          '<details class="wd-faq__q"', open ? ' open' : '', '>',
          '<summary class="wd-faq__q-head"><span class="wd-faq__q-title">', esc(question), '</span><span class="wd-faq__q-chev material-symbols-outlined">expand_more</span></summary>',
          '<div class="wd-faq__q-body"><p>', answer, '</p></div>',
          '</details>'
        ].join('');
      }

      var lightAnswer = isFloor
        ? esc(productTitle) + ' creates one strong pool of warm ' + esc(colorTemperature) + ' light: enough for reading on the sofa, winding down, or turning the overhead off in that zone. Larger rooms usually feel best with a table lamp on the opposite side.'
        : isTable
          ? esc(productTitle) + ' is a table-height layer, not the only light for a full room. It is right for a bedside, sofa, console, shelf, or quiet evening task zone. Pair it with a floor lamp across the room when you want the overhead off.'
          : esc(productTitle) + ' creates one useful pool of warm ' + esc(colorTemperature) + ' light. Most finished rooms use more than one lamp, so pair it with another light across the room if you want the overhead off.';

      var dimAnswer = isDimmable
        ? 'Yes. ' + esc(productTitle) + ' is listed as dimmable' + (bulbText ? ' and uses a ' + esc(bulbText) + ' bulb/base' : '') + '. Keep replacements at ' + esc(colorTemperature) + ' and use a compatible dimmable bulb or switch setup.'
        : esc(productTitle) + (bulbText ? ' uses a ' + esc(bulbText) + ' bulb/base. ' : '. ') + 'If dimming is not listed in the specs, treat it as fixed-output and keep replacement bulbs at ' + esc(colorTemperature) + '.';

      var placeAnswer = isFloor
        ? 'Beside a sofa, next to a reading chair, in a lounge corner, or anywhere a vertical pool of warm light can replace the overhead in one seating zone.'
        : isTable
          ? 'On a nightstand, side table, low console, shelf, or kitchen corner: anywhere a small pool of warm light makes the room feel softer after dark.'
          : 'Place it where you actually spend time after dark: beside the sofa, near the bed, by a reading chair, or in the corner that feels unfinished under overhead light.';

      faqList.innerHTML = [
        item('Do I need an electrician?', 'No. ' + esc(productTitle) + ' plugs into a standard US outlet or uses the power setup listed in the specs. No ceiling work, no hardwiring, no switch installation. Unbox, power it, done.', true),
        item('How long does shipping take?', 'Standard US shipping is free on every order. ' + esc(productTitle) + ' is made to order and typically ships in about 4 weeks, with tracking sent the moment it leaves the workshop.'),
        item('What if it arrives damaged, or I change my mind?', 'Every order is packed for furniture-grade transit and fully insured. If anything arrives less than perfect, we replace it. If you simply change your mind, you have 30 days from delivery to start a return through our <a href="/pages/returns" class="wd-faq__link">returns page</a>. Manufacturing defects are covered by a 1-year warranty.'),
        item('How bright is ' + productTitle + ', and is one enough?', lightAnswer),
        item('Can I dim it, and what bulb does it use?', dimAnswer),
        item('How does the Room Pair Bonus work?', 'Add any two qualifying lamps and the cart unlocks a Pocket mini lamp and a spare 2700K bulb. No code, no opt-in, while supplies last. If you remove lamps and the cart drops below two, the gifts are removed.'),
        item('Where in my home does ' + productTitle + ' work best?', placeAnswer)
      ].join('');
      faqList.dataset.wbdPdpFaqPatched = 'true';
    }

    ready(function() {
      if (pageType) {
        renderStaticPage(pageType);
        setTimeout(function() { renderStaticPage(pageType); }, 800);
      }
      patchProductCopy();
      patchProductFaq();
      setTimeout(patchProductFaq, 500);
      setTimeout(patchProductFaq, 1500);
    });
  }

  function installCollectionCacheBridge() {
    if (!/^\/collections\/best-sellers\/?$/.test(window.location.pathname)) return;

    var hasCurrentCollection = document.querySelector('.wd-coll-hero__bg') && document.querySelector('[data-collection-kit-modal]');
    var looksStaleCollection = document.querySelector('.wd-filter__summary') || document.querySelector('.kit-cta-section') || !hasCurrentCollection;
    if (!looksStaleCollection || window.location.search.indexOf('view=ajax') !== -1) return;

    var nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('view', 'ajax');
    window.location.replace(nextUrl.toString());
  }

  function installCollectionCardImageLoader() {
    if (window.__wbdCollectionCardImageLoader) return;
    window.__wbdCollectionCardImageLoader = true;

    function forceCardImage(card) {
      var img = card && card.querySelector ? card.querySelector('.wd-card__img') : null;
      if (!img || (img.complete && img.naturalWidth > 0)) return;
      var src = img.currentSrc || img.getAttribute('src');
      if (!src) return;
      try {
        src = new URL(src, window.location.href).href;
      } catch (error) {}
      img.loading = 'eager';
      if (img.dataset.wdLoadKick === src) return;
      img.dataset.wdLoadKick = src;
      var preload = new Image();
      preload.decoding = 'async';
      preload.onload = function() {
        if (!img.complete || img.naturalWidth === 0) img.src = src;
      };
      preload.src = src;
    }

    function scan() {
      document.querySelectorAll('.wd-card:not([hidden])').forEach(forceCardImage);
    }

    scan();
    window.addEventListener('load', scan);
    document.addEventListener('click', function(event) {
      if (event.target.closest('[data-collection-filter], .wd-pagination a[href]')) {
        window.setTimeout(scan, 60);
        window.setTimeout(scan, 350);
      }
    });
    document.addEventListener('change', function(event) {
      if (event.target.matches('.wd-sort__select')) {
        window.setTimeout(scan, 60);
        window.setTimeout(scan, 350);
      }
    });
    if ('MutationObserver' in window) {
      new MutationObserver(scan).observe(document.documentElement, {
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden']
      });
    }
  }

  function installWarmLampsRouteBridge() {
    /* Cache-busted 2026-05-12 so stale collection URLs normalize on live. */
    var stalePath = '/collections/warm-light-lamps';
    var livePath = '/collections/warm-lamps';

    function rewriteWarmLampLinks() {
      document.querySelectorAll('a[href*="' + stalePath + '"]').forEach(function(anchor) {
        var url;
        try {
          url = new URL(anchor.getAttribute('href'), window.location.origin);
        } catch (err) {
          return;
        }
        if (url.origin !== window.location.origin || url.pathname !== stalePath) return;
        url.pathname = livePath;
        anchor.setAttribute('href', url.pathname + url.search + url.hash);
      });
    }

    if (window.location.pathname === stalePath) {
      var nextUrl = new URL(window.location.href);
      nextUrl.pathname = livePath;
      window.location.replace(nextUrl.toString());
      return;
    }

    rewriteWarmLampLinks();
    document.addEventListener('shopify:section:load', rewriteWarmLampLinks);
  }

  function patchCollectionLaunchImage() {
    if (window.location.pathname.indexOf('/collections/') !== 0) return;
    var script = document.currentScript || document.querySelector('script[src*="theme-pdp-fix2.js"]');
    var assetUrl = '//warmbydesign.com/cdn/shop/t/12/assets/wbd-launch-kit-collection.png?v=158294924955298948781778302319';
    if (script && script.src) {
      assetUrl = script.src.replace(/theme-pdp-fix2\.js(?:\?.*)?$/, 'wbd-launch-kit-collection.png?v=158294924955298948781778302319');
    }

    document.querySelectorAll('.wd-launch-card__visual').forEach(function(visual) {
      var img = visual.querySelector('img');
      if (!img || img.src.indexOf('wbd-launch-banner-bg.jpg') === -1) return;
      visual.style.aspectRatio = '1448 / 1086';
      visual.style.minHeight = '0';
      img.src = assetUrl;
      img.width = 1448;
      img.height = 1086;
      img.style.objectFit = 'contain';
      img.style.objectPosition = 'center';
      img.style.opacity = '1';
      img.style.filter = 'saturate(0.98) contrast(1.02) brightness(1.08)';
    });
  }

  installMerchantMisrepRenderPatch();
  installCollectionCacheBridge();
  installCollectionCardImageLoader();
  installWarmLampsRouteBridge();
  patchCollectionLaunchImage();
  installReviewComposerOverrides();
  installReviewWidgetLoader();
})();
